/**
 * THE LAST-MANAGER FLOOR, client mirror (owner ruling 2026-10-08).
 *
 * A department must always keep one active member who can give others a role.
 * The SERVER is the gate (`server/helpers/departmentManagerFloor.js`, 409
 * `last_department_manager`); the client only mirrors it so people do not hit
 * it. It never counts holders itself: the server stamps `last_manager_locked`
 * (and, on a locked seat, `last_manager_roles` — the roles it may still move
 * to) on the members list, the person detail and the leave check.
 *
 * The reason is TEXT and names no role (ruling 8: cite the capability, never
 * "buyer or supervisor").
 */
export const LAST_MANAGER_REASON =
  "Only person here who can manage this department. Give someone else that access first.";

/** True when this role option must be disabled on this seat. */
export function lastManagerBlocksRole(seat, role) {
  if (!seat || !seat.last_manager_locked) return false;
  const keep = Array.isArray(seat.last_manager_roles) ? seat.last_manager_roles : [];
  return role !== seat.role && !keep.includes(role);
}
